import { getAttributionContext } from "./attribution-context";

export const identify = ({ ...data }) => {
  if (process.env.NEXT_PUBLIC_ENVIRONMENT === "local") {
    console.log("identify", { ...data });
  }
  if (typeof window?.analytics?.track === "undefined") return;

  const attribution = getAttributionContext();
  const options = attribution ? { context: attribution } : undefined;

  if (data.userId) {
    return window.analytics.identify(
      data.userId,
      {
        ...data,
      },
      options
    );
  }

  window.analytics.identify(
    {
      ...data,
    },
    options
  );
};
